export const DELETE_LOADING_MESSAGE_ID = 'delete-message';
